import { render, staticRenderFns } from "./FormControlPlainText.vue?vue&type=template&id=3455917c&scoped=true"
import script from "./FormControlPlainText.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlPlainText.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlPlainText.vue?vue&type=style&index=0&id=3455917c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3455917c",
  null
  
)

export default component.exports